import Vuetify from 'vuetify/lib';

export default {
  setup: function () {
    return new Vuetify({
      breakpoint: {
        mobileBreakpoint: 'sm' // This is equivalent to a value of 960
      },
      theme: {
        themes: {
          light: {
            primary: '#5270ff',
            accent: '#78e3ed',
            darkBlue: '#000048',
            lightBlue: '#45d9e6'
            // success: '#75f21b'
          }
        }
      }
    });
  }
};
